import './component.scss'
import $ from 'jquery'
import 'Components/refosumu/basics/breadcrumb/component'
import 'Components/refosumu/carousel_light/component'
import 'Components/refosumu/example_card/component'
import 'Components/refosumu/review_card/component'
import 'Components/refosumu/company_card/component'
import 'Components/basics/truncate_text/component'
import './images/refolow.webp'
import './images/customer_request.webp'
import './images/company_request.webp'
import './images/icon.svg'
import './images/yellow-arrow.svg'
import './images/in_preparation.webp'
import './images/yen_mark_blue.svg'
import '@splidejs/splide/css';
import { Splide } from '@splidejs/splide';

// スライダー初期化関数
function initializeSliders () {
  // .splideの要素を全て取得
  const splideTargets = $('.splide')
  splideTargets.each((_, splideTarget) => {
    // スライド数を取得
    const slideCount = $(splideTarget).find('.splide__slide').length

    // スライダーを初期化
    const SP_PER_PAGE = 1;
    const SLIDER_CONFIG = {
      speed: 800,
      perPage: SP_PER_PAGE,
      perMove: SP_PER_PAGE,
      pagination: false,
      arrows: slideCount > 1, // スライドが1枚のみの場合は矢印を非表示
      focus: 'center',
    };

    new Splide(splideTarget, SLIDER_CONFIG).mount()
  })
}

function initializeImageSwitcher() {
  const mainImage = document.querySelector('.renovation-example__photo')
  const subImages = document.querySelectorAll('.renovation-example__area-img')

  subImages.forEach(subImage => {
    subImage.addEventListener('click', (e) => {
      if (e.target.classList.contains('renovation-example__area-img--active')) return

      // サブ画像の選択状態切り替え
      subImages.forEach(img => {
        img.classList.remove('renovation-example__area-img--active')
      })
      e.target.classList.add('renovation-example__area-img--active')

      // 旧メイン画像をフェードアウト
      mainImage.classList.add('renovation-example__photo--fade-out')

      setTimeout(() => {
        mainImage.src = e.target.src

        // 新メイン画像をフェードイン
        mainImage.onload = () => {
          mainImage.classList.remove('renovation-example__photo--fade-out')
        }
      }, 300) // CSS transitionの時間と合わせる
    })
  })
}

// タブ機能の実装
document.addEventListener('DOMContentLoaded', function () {
  // タブアイテムとコンテナを取得
  const tabItems = document.querySelectorAll('.renovation-example__tab-item')
  const tabContainers = document.querySelectorAll('.renovation-example__tab-inner-container')

  // 初期表示の設定
  function initializeTabs () {
    // 全てのコンテナを非表示に
    tabContainers.forEach(container => {
      container.classList.remove('renovation-example__tab-inner-container--visible')
    })

    // アクティブなタブに対応するコンテナを表示
    const activeTab = document.querySelector('.renovation-example__tab-item--active')
    if (activeTab) {
      const tabKey = activeTab.getAttribute('data-tab-key')
      const targetContainer = document.querySelector(`[data-tab-key="${tabKey}"].renovation-example__tab-inner-container`)
      if (targetContainer) {
        targetContainer.classList.add('renovation-example__tab-inner-container--visible')
      }
    }
  }

  // タブクリック時の処理
  function handleTabClick (clickedTab) {
    const tabKey = clickedTab.getAttribute('data-tab-key')

    // 全タブのアクティブ状態をリセット
    tabItems.forEach(tab => {
      tab.classList.remove('renovation-example__tab-item--active')
    })

    // クリックされたタブをアクティブに
    clickedTab.classList.add('renovation-example__tab-item--active')

    // 全コンテナを非表示に
    tabContainers.forEach(container => {
      container.classList.remove('renovation-example__tab-inner-container--visible')
    })

    // 対応するコンテナを表示
    const targetContainer = document.querySelector(`[data-tab-key="${tabKey}"].renovation-example__tab-inner-container`)
    if (targetContainer) {
      targetContainer.classList.add('renovation-example__tab-inner-container--visible')
    }
  }

  // イベントリスナーを設定
  tabItems.forEach(tab => {
    tab.addEventListener('click', function () {
      handleTabClick(this)
    })
  })

  // FV画像切り替え機能を初期化
  initializeImageSwitcher()

  // 初期化実行
  initializeTabs()

  // スライダー初期化
  initializeSliders()
})
